import http from './axiosInstance'
import transformPlans from '../../api/v4/transformers/plans'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'

export const fetchPromo = async (promo = 'default'): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/promos/${promo}`)
    const data: any = {}
    const { plans, stripeDiscount } = response.data.data
    data.plans = transformPlans(plans, stripeDiscount)
    data.promo = response.data.data
    resp.data = data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const updateApprovalStatus = async (
  domain: string,
  id: number,
  status: boolean,
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`/domains/${domain}/approveDenyDomainUpgrade`, {
      id,
      status,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
